var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBannerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#4316B8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9567 14.9737C24.0997 15.5072 23.7831 16.0555 23.2496 16.1985C22.7161 16.3414 22.1678 16.0248 22.0249 15.4913C21.8819 14.9579 22.1985 14.4095 22.732 14.2666C23.2654 14.1237 23.8138 14.4402 23.9567 14.9737Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9085 18.0722C23.0514 18.6057 22.7349 19.154 22.2014 19.297C21.6679 19.4399 21.1196 19.1233 20.9767 18.5899C20.8337 18.0564 21.1503 17.5081 21.6838 17.3651C22.2172 17.2222 22.7656 17.5388 22.9085 18.0722Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4799 19.747C11.3727 19.3469 11.6101 18.9357 12.0102 18.8285L13.2176 18.505L12.8941 17.2976C12.7869 16.8975 13.0243 16.4862 13.4244 16.379C13.8245 16.2718 14.2358 16.5092 14.343 16.9093L14.6665 18.1167L15.8739 17.7932C16.274 17.686 16.6853 17.9234 16.7925 18.3235C16.8997 18.7236 16.6623 19.1349 16.2622 19.2421L15.0548 19.5656L15.3783 20.773C15.4855 21.1731 15.248 21.5844 14.848 21.6916C14.4479 21.7988 14.0366 21.5614 13.9294 21.1613L13.6059 19.9538L12.3985 20.2774C11.9984 20.3846 11.5871 20.1471 11.4799 19.747Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.37472 20.847C6.48317 17.5197 8.45773 14.0997 11.785 13.2082L20.9862 10.7427C24.3135 9.85115 27.7335 11.8257 28.6251 15.153C29.5166 18.4803 27.5421 21.9003 24.2148 22.7919L15.0136 25.2573C11.6863 26.1489 8.26626 24.1743 7.37472 20.847ZM12.1474 14.5604L21.3486 12.095C23.929 11.4036 26.5814 12.9349 27.2728 15.5154C27.9642 18.0958 26.4329 20.7482 23.8524 21.4396L14.6512 23.905C12.0708 24.5965 9.41844 23.0651 8.72701 20.4847C8.03559 17.9042 9.56693 15.2519 12.1474 14.5604Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerIcon);
export default __webpack_public_path__ + "static/media/banner_icon.7eda7227caad2f31788b933b075ea802.svg";
export { ForwardRef as ReactComponent };